import { render } from "./MenuListItem.vue?vue&type=template&id=ba7e48e8&scoped=true"
import script from "./MenuListItem.vue?vue&type=script&lang=js"
export * from "./MenuListItem.vue?vue&type=script&lang=js"

import "./MenuListItem.vue?vue&type=style&index=0&id=ba7e48e8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba7e48e8"]])

export default __exports__